import React from 'react';

import Helmet from 'common/helmets/Helmet';

const Title = 'Document360 Case Study | Canny';
const Description =
  'Read about how Document360 uses Canny to be customer-obsessed and close new business';
const Image = 'https://canny.io/images/e118b699e2e1b7291a2448eb5990465a.jpg';

const Document360LandingHelmet = () => {
  return (
    <Helmet
      title={Title}
      meta={[
        { name: 'description', content: Description },

        { property: 'og:image', content: Image },
        { property: 'og:title', content: Title },
        { property: 'og:description', content: Description },
        { property: 'og:url', content: 'https://canny.io/case-studies/document360' },
        { property: 'og:type', content: 'website' },

        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:site', content: '@cannyHQ' },
        { name: 'twitter:title', content: Title },
        { name: 'twitter:description', content: Description },
        { name: 'twitter:image', content: Image },
      ]}
    />
  );
};

export default Document360LandingHelmet;
